<template>
  <b-button v-on:click="mylogout"
               :size="size"
               class="bg-light text-dark">
    {{ mylogout_text() }}
    <!-- <i class="fas fa-power-off"></i> -->
  </b-button>
</template>

<script>
import baseButton from '@/components/backoffice/button/base'
import bButton from 'bootstrap-vue/es/components/button/button'
import SecurityAPI from '@/api/security'

export default {
  components: {
    baseButton,
    bButton
  },
  props: {
    size: String
  },
  methods: {
    mylogout: function (event) {
      if (this.$store.getters['security/isImpersonated']) {
        SecurityAPI.impersonate()
      } else {
        this.$store.dispatch('security/logout')
          .then(() => {
            this.$router.push({ path: '/login' })
          })
      }
    },

    mylogout_text: function () {
      if (this.$store.getters['security/isImpersonated']) {
        return this.$t('logout.cancelImpersonate')
      } else {
        return this.$t('_logout')
      }
    }
  }
}
</script>
